"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Nov 08 2018
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * Window file model object representing relation between {@link Window window} and file.
 *
 * @author OPt
 */


var WindowFile =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowFile, _DomainObject_1$Domai);

  /**
   * Creates new instance of WindowFile.
   * @param id ID of the WindowFile
   * @param fileId ID of the file
   * @param windowId ID of the Window
   * @param uploadedBy user who uploaded the file
   * @param note note
   */
  function WindowFile(id, fileId, windowId, uploadedBy, note) {
    var _this;

    _classCallCheck(this, WindowFile);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowFile).call(this));
    _this.id = id;
    _this.fileId = fileId;
    _this.windowId = windowId;
    _this.uploadedBy = uploadedBy;
    _this.note = note;
    return _this;
  }

  return WindowFile;
}(DomainObject_1.DomainObject);

exports.WindowFile = WindowFile;

WindowFile.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowFile.name);
  return {
    id: builder.id('id'),
    fileId: builder.str('fileId'),
    windowId: builder.str('windowId'),
    uploadedBy: builder.obj('uploadedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    note: builder.opt(builder.str('note'))
  };
}();